<script setup>
import { ref } from "vue";
import axios from "axios";
import { toast } from "vue3-toastify";
import "vue3-toastify/dist/index.css";
import { useAuthStore } from "@/store/auth";
import FullScreenLoader from "@/components/FullScreenLoader.vue";

import {
  loaderState,
  showLoader,
  hideLoader,
} from "../../utils/loader/loader.js";

const authStore = useAuthStore();

const allData = ref(authStore.infoAcces.mandatos);
const selectedMandato = ref("");
const selectedFile = ref(null);

// Tipos de archivo permitidos
const allowedTypes = [
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "application/pdf",
  "text/csv",
];

const onFileChange = (event) => {
  const file = event.target.files[0];
  if (file && !allowedTypes.includes(file.type)) {
    toast.error("Solo se permiten archivos .xlsx, .pdf o .csv");
    selectedFile.value = null;
    event.target.value = "";
    return;
  }
  selectedFile.value = file;
};

const uploadFile = async () => {
  if (!selectedMandato.value || !selectedFile.value) {
    toast.error("Debe seleccionar un mandato y un archivo válido.");
    return;
  }

  showLoader();

  const formData = new FormData();
  formData.append("archivo", selectedFile.value);

  try {
    const response = await axios.post(
      "https://miportal.afcoma.com.mx/v2/apifiles/files",
      formData,
      {
        headers: {
          "x-api-key": "4{C4:#o&2,sM-2=DiiZN*kZe5|mu{",
          "Content-Type": "multipart/form-data",
          Email: authStore.infoAcces.email,
          Mandato: selectedMandato.value,
        },
      }
    );

    if (response.data.error) {
      toast.error(response.data.mensaje);
    } else {
      toast.success(response.data.mensaje);
    }
  } catch (error) {
    toast.error(
      "Error al subir el archivo, favor de contactar al administrador."
    );
  }

  hideLoader();
};
</script>

<template>
  <div class="card">
    <div class="card-header pb-0">
      <h6 class="mb-0">Archivos</h6>
    </div>

    <div class="card-body px-3 pt-3 pb-2">
      <!-- Select de mandato -->
      <div class="form-group mb-4">
        <label for="mandatoSelect" class="form-control-label"
          >Seleccionar mandato</label
        >
        <select
          id="mandatoSelect"
          v-model="selectedMandato"
          class="form-select"
        >
          <option disabled value="">-- Selecciona un mandato --</option>
          <option v-for="item in allData" :key="item" :value="item">
            {{ item }}
          </option>
        </select>
      </div>

      <!-- Subida de archivo -->
      <div class="form-group mb-4">
        <label for="fileUpload" class="form-control-label">Subir archivo</label>
        <input
          type="file"
          id="fileUpload"
          class="form-control"
          accept=".xlsx, .pdf, .csv"
          @change="onFileChange"
        />
      </div>
      <p class="text-justify text-sm">
        Le recordamos que tiene habilitada la opción de cargar la información a
        través de una API. Para cualquier duda o requerimiento de apoyo,
        comuníquese por correo electrónico a
        <a href="mailto:soporte@afcoma.com.mx" class="fw-bold">
          <strong>soporte@afcoma.com.mx</strong>
        </a>
        con gusto le atenderemos.
      </p>
      <!-- Botón de subida -->
      <div class="form-group mb-4 text-center">
        <button class="btn btn-primary" @click="uploadFile">
          Subir archivo
        </button>
      </div>
    </div>

    <full-screen-loader :isVisible="loaderState.isVisible" />
  </div>
</template>
